import React, { Component } from 'react';

import './LoadingSpinner.css';

export default class LoadingSpinner extends Component {
  render() {
    return (
      <div className='LoadingSpinner'>
        <div className='LoadingSpinner-bounce1' />
        <div className='LoadingSpinner-bounce2' />
        <div className='LoadingSpinner-bounce3' />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/global/LoadingSpinner/LoadingSpinner.js